export default "__VITE_ASSET__nkLcf_0g__"